import React, { useState, useEffect } from "react";
import { setEditorSaved } from "../../../../../../../redux/actions/integrationActions";
import { useDispatch, useSelector } from "react-redux";
import Button from "@atlaskit/button/new";
import Select from "@atlaskit/select";
import { Flex, Flex1, Flex2, Flex5 } from "../../../../../../../common/style";
import { ConditionType } from "../../../../../../../common/interfaces/flow/condition/ConditionType";
import { createCondition } from "../../../../../../../common/factory/condition.factory";

const CONDITION_TYPES = [
  { label: "Data Condition", value: ConditionType.DATA_CONDITION },
  { label: "HTTP Status Condition", value: ConditionType.HTTP_STATUS_CODE_CONDITION },
];
const CombinedConditionControl = ({ conditions, addCombinedCondition, title }) => {
  const [conditionTypeSelectOption, setConditionTypeSelectOption] = useState(CONDITION_TYPES[0]);
  const dispatch = useDispatch();
  const saved = useSelector((state) => state.integration.saved);

  useEffect(() => {}, []);
  const onChangeConditionType = (selected) => {
    setConditionTypeSelectOption(selected);
  };
  const onAddCombinedCondition = () => {
    const newCombinedCondition = createCondition(ConditionType.COMBINED_CONDITION);
    newCombinedCondition.conditions.push(createCondition(conditionTypeSelectOption.value));
    conditions ? conditions.push(newCombinedCondition) : (conditions = [newCombinedCondition]);
    if (saved) {
      dispatch(setEditorSaved(false));
    }
    addCombinedCondition(conditions);
  };

  return (
    <Flex>
      <Flex2>
        <Select
          options={CONDITION_TYPES}
          spacing="compact"
          name="selectConditionType"
          className="ihub-action-condition-select"
          value={conditionTypeSelectOption}
          onChange={onChangeConditionType}
        />
      </Flex2>
      <Flex5>
        &ensp;&ensp;
        <Button onClick={onAddCombinedCondition} appearance="primary">
          {title}
        </Button>
      </Flex5>
    </Flex>
  );
};

export default CombinedConditionControl;
